// @flow
import { useCallback, useState, useRef } from 'react';

import FilterSection from '../catalogFilters/FilterSection';
import FilterCheckItem from '../catalogFilters/FilterCheckItem';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as ContourContent from '@components/popups/content/Contour';

import css from '@styles/bandFilters';

type TProps = {
  checked: boolean,
  onChange: (C: boolean) => void
};

export default function ContourFilter({ checked, onChange }: TProps) {
  const handleCheckToggle = useCallback(e => {
    onChange(e.currentTarget.checked);
  }, []);

  return (
    <FilterCheckItem
      className={css.contour}
      label='<span class="include">include </span>contour<span class="styles"> styles</span>'
      inputValue={true}
      htmlId='include-contour'
      popup={({ className }) => (
        <QuestionMarkPopup
          initialContent={ContourContent}
          className={className}
          doNotScrollToPopup
        />
      )}
      selected={checked}
      onChange={handleCheckToggle}
      ElementType={'div'}
    />
  );
}
